'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _getNested = require('get-nested');

var _getNested2 = _interopRequireDefault(_getNested);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WebformUtils = function () {
  function WebformUtils() {
    (0, _classCallCheck3.default)(this, WebformUtils);
  }

  (0, _createClass3.default)(WebformUtils, null, [{
    key: 'getCustomValue',
    value: function getCustomValue(field, key, settings) {
      if (key.startsWith('#')) {
        throw new Error('Please use the field without leading hash.');
      }

      if (field['#override_' + key]) {
        return field['#' + key];
      }

      return (0, _getNested2.default)(function () {
        return settings.custom_elements[key]['#default_value'];
      }, null);
    }
  }, {
    key: 'getErrorMessage',
    value: function getErrorMessage(field, key) {
      var errorMessage = (0, _getNested2.default)(function () {
        return field[key];
      }, null);
      return errorMessage && errorMessage !== '' ? errorMessage : null;
    }
  }, {
    key: 'validateRule',
    value: function validateRule(rule, field) {
      var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (!rule) return true;else if (force || !rule.shouldValidate || rule.shouldValidate(field)) {
        return rule.rule(field.getValue());
      }
      return true;
    }

    /**
     * @deprecated
     * @param field
     * @param value
     * @returns {boolean}
     */

  }, {
    key: 'isEmpty',
    value: function isEmpty(field, value) {
      if (value === '' || value === false) {
        return true;
      }

      if (field && field['#mask']) {
        var mask = field['#mask'].replace(/9|a|A/g, '_');
        return value === mask;
      }

      return false;
    }
  }]);
  return WebformUtils;
}();

exports.default = WebformUtils;